import { $devError } from './devLog';

export function swallowAndLogException(action) {
  try {
    action();
  }
  catch (err) {
    $devError(err);
  }
}